@if (isOpen) {
  <div
    class="fixed inset-0 z-[99999] bg-black/50 flex items-center justify-center p-4"
    (click)="cancel()"
  >
    <div
      class="w-full max-w-3xl max-h-[90vh] flex flex-col rounded-2xl bg-white dark:bg-gray-900 shadow-2xl overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div>
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ title }}
          </h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            @if (mode === 'EXCLUDE') {
              Estos contactos no recibirán este envío aunque caigan en algún segmento.
            } @else {
              Adjuntá contactos individuales como destinatarios de este correo.
            }
          </p>
        </div>
        <button type="button" (click)="cancel()"
          class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Search -->
      <div class="p-4 border-b border-gray-100 dark:border-gray-800">
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          placeholder="Buscar por nombre o email…"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        />
        <div class="mt-2 flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
          <span>{{ totalElements }} contactos</span>
          @if (selectedIds.size > 0) {
            <span class="font-medium text-teal-600 dark:text-teal-300">
              {{ selectedIds.size }} seleccionado{{ selectedIds.size === 1 ? '' : 's' }}
            </span>
          }
        </div>
      </div>

      <!-- Error -->
      @if (error) {
        <div class="mx-4 my-2 rounded-lg bg-red-50 dark:bg-red-900/20 p-3 text-sm text-red-700 dark:text-red-300">
          {{ error }}
        </div>
      }

      <!-- List -->
      <div class="flex-1 overflow-y-auto">
        @if (loading && rows.length === 0) {
          <div class="p-6 space-y-3">
            <div class="h-12 animate-pulse rounded-lg bg-gray-100 dark:bg-gray-800"></div>
            <div class="h-12 animate-pulse rounded-lg bg-gray-100 dark:bg-gray-800"></div>
            <div class="h-12 animate-pulse rounded-lg bg-gray-100 dark:bg-gray-800"></div>
          </div>
        } @else if (rows.length === 0) {
          <div class="p-10 text-center text-sm text-gray-500 dark:text-gray-400">
            No se encontraron contactos.
          </div>
        } @else {
          <ul class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (c of rows; track c.id) {
              <li
                class="flex items-center gap-3 px-4 py-3"
                [class.opacity-50]="isAlreadyAttached(c.id)"
                [class.cursor-not-allowed]="isAlreadyAttached(c.id)"
                [class.cursor-pointer]="!isAlreadyAttached(c.id)"
                (click)="!isAlreadyAttached(c.id) && toggle(c.id)"
              >
                <input
                  type="checkbox"
                  [checked]="isSelected(c.id)"
                  [disabled]="isAlreadyAttached(c.id)"
                  (click)="$event.stopPropagation()"
                  (change)="toggle(c.id)"
                  class="h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                />
                <div class="h-9 w-9 rounded-full bg-teal-100 dark:bg-teal-900/40 text-teal-700 dark:text-teal-300 flex items-center justify-center text-xs font-semibold">
                  {{ initialsOf(c) }}
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-sm font-medium text-gray-900 dark:text-white/90 truncate">
                    {{ fullNameOf(c) }}
                  </p>
                  <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
                    {{ c.mail }}
                  </p>
                </div>
                @if (isAlreadyAttached(c.id)) {
                  <span class="text-xs text-gray-500 dark:text-gray-400">Ya en la lista</span>
                }
              </li>
            }
          </ul>
          @if (hasMore) {
            <div class="p-4 text-center">
              <button (click)="loadMore()"
                [disabled]="loading"
                class="rounded-lg border border-gray-300 dark:border-gray-700 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50">
                {{ loading ? 'Cargando…' : 'Cargar más' }}
              </button>
            </div>
          }
        }
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end gap-2 px-6 py-3 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
        <button (click)="cancel()" type="button"
          class="px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800">
          Cancelar
        </button>
        <button (click)="confirm()" type="button"
          [disabled]="selectedIds.size === 0"
          [class.bg-red-600]="mode === 'EXCLUDE'"
          [class.hover:bg-red-700]="mode === 'EXCLUDE'"
          [class.bg-teal-600]="mode === 'INCLUDE'"
          [class.hover:bg-teal-700]="mode === 'INCLUDE'"
          class="px-4 py-2 text-sm rounded-lg text-white disabled:opacity-50 disabled:cursor-not-allowed">
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
}
